export const resultValues={
    resultType:"Demo",
    resultReason:"",
    oneLeg:"mr",
    lastPrice:""
  }